/**
 * This is the tag when you need it to be a link.
 * Clicks bring you to the category page.
 */

import { Link } from "react-router-dom";

import { nFormatter } from "@/common/utils/parseNumber";
import { INiche, ITag } from "@/common/services/types";
import { routes } from "@/common/utils/routes";
import { clsx } from "clsx";
import { useCallback } from "react";
import DefaultUserIcon from "@/common/images/icons/profileIcon.svg";

import "./styles.scss";
import { SearchInitiator, useAnalyticsStore } from "@/common/store/analyticsStore";
import { useSfw } from "@/common/hooks/useSfw";

interface ITagLinkProps {
  tag: INiche | ITag;
  counts: boolean;
  onClick?: () => void;
}

export const TagLink = ({ tag, counts, onClick }: ITagLinkProps) => {
  const isOfTypeNiche = (someTag: INiche | ITag): someTag is INiche => "id" in someTag;
  const isNiche = isOfTypeNiche(tag);
  const setSearchInitiator = useAnalyticsStore((state) => state.setSearchInitiator);
  const { isLoading, sanitizeImage } = useSfw();

  const handleClick = useCallback(() => {
    setSearchInitiator(SearchInitiator.TagLink);

    if (onClick) {
      onClick();
    }
  }, [isNiche, onClick]);

  let nicheThumbnail = null;

  if (isNiche) {
    nicheThumbnail = tag.thumbnail ? sanitizeImage(tag.thumbnail) : DefaultUserIcon;
  }

  if (isLoading) {
    return null;
  }

  return (
    <Link
      to={isNiche ? routes.niche(tag.id) : routes.singleTag(tag.name)}
      onClick={handleClick}
      className={clsx("tagItem", isNiche && "tagItemNiche")}
      title={tag.name}
    >
      {nicheThumbnail && (
        <img className="icon" loading="lazy" src={nicheThumbnail} width="24" height="24" alt={`Poster for ${tag.name} tag`} />
      )}

      {tag.name}

      {counts && (
        <span className="count">{nFormatter(isNiche ? tag.gifs : tag.count)}</span>
      )}
    </Link>
  );
};
